import { render, staticRenderFns } from "./workResident.vue?vue&type=template&id=12f52df5&scoped=true"
import script from "./workResident.vue?vue&type=script&lang=js"
export * from "./workResident.vue?vue&type=script&lang=js"
import style0 from "./workResident.vue?vue&type=style&index=0&id=12f52df5&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f52df5",
  null
  
)

export default component.exports